module.exports = __webpack_public_path__ + "img/MariaL.cd6adae9.jpg";